import React from 'react';
import { Cpu } from 'lucide-react';

const getProgressClasses = (pct) => {
    if (pct <= 10) return "from-red-500 to-rose-600"; // Red when 10% or fewer credits left
    if (pct <= 40) return "from-amber-500 to-orange-600"; // Orange when 40% or fewer credits left
    return "from-emerald-500 to-green-600"; // Green otherwise
};

const UsageCard = ({ title, used = 0, limit = 0, Icon }) => {
    const pct = limit > 0 ? Math.min(100, Math.round((1 - (used / limit)) * 100)) : 0;
    const remaining = limit - used;
    const gradient = getProgressClasses(pct);
    const exceeded = limit > 0 && used >= limit;
    const trackClasses = exceeded ? "bg-red-100 border-red-200" : "bg-gray-100 border-gray-200";
    const barClasses = exceeded ? "bg-red-500" : `bg-gradient-to-r ${gradient}`;
    return (
        <div className="relative p-5 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow min-h-[140px] flex flex-col justify-between overflow-visible">
            {exceeded && (
                <span className="absolute -top-2 -right-2 px-2 py-1 text-[11px] font-semibold rounded-full bg-red-100 text-red-700 border border-red-200 shadow-sm">
                    Exceeded
                </span>
            )}

            <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0">
                    {Icon && <Icon className="h-5 w-5 text-gray-700" />}
                </div>
                <div className="flex-1">
                    <h3 className="text-sm font-semibold text-gray-900 leading-5">{title}</h3>
                    {/* <div className="mt-1 text-xs text-gray-600">
                        <span className="font-semibold text-gray-900">{remaining}</span>
                        <span className="ml-1">left</span>
                        {limit > 0 && <span className="ml-2 text-gray-400">({pct}%)</span>}
                    </div> */}
                </div>
            </div>

            <div className="mt-1 h-2 w-full flex rounded-full bg-gray-200 overflow-hidden">
    <div className="h-full bg-emerald-500" style={{ width: `${pct}%` }} />
    <div className="h-full bg-red-500" style={{ width: `${100 - pct}%` }} />
</div>

            <div className="mt-1 text-xs text-gray-600">
    <span className="font-semibold text-gray-900">{remaining}</span>
    <span className="ml-1">left</span>
    <span className="mx-1">/</span>
    <span className="font-semibold text-gray-900">{used}</span>
    <span className="ml-1">used</span> <br/>
    {limit > 0 && <span className="ml-1 text-gray-400">({pct}% left)</span>}
</div>


        </div>
    );
};

export default UsageCard;
